var _mask, _path, _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddCourseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "addCourseIcon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9a1 1 0 00-1 1v4.5h-4.5a1 1 0 100 2H15V21a1 1 0 102 0v-4.5h4.5a1 1 0 100-2H17V10a1 1 0 00-1-1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.5v2h2v-2h-2zm0 2h2v-2h-2v2zm2 0v-2h-2v2h2zm0-2h-2v2h2v-2zm0-4.5a1 1 0 01-1 1V7a3 3 0 00-3 3h4zm0 4.5V10h-4v4.5h4zm-6.5 2H15v-4h-4.5v4zm1-1a1 1 0 01-1 1v-4a3 3 0 00-3 3h4zm-1-1a1 1 0 011 1h-4a3 3 0 003 3v-4zm4.5 0h-4.5v4H15v-4zm2 6.5v-4.5h-4V21h4zm-1-1a1 1 0 011 1h-4a3 3 0 003 3v-4zm-1 1a1 1 0 011-1v4a3 3 0 003-3h-4zm0-4.5V21h4v-4.5h-4zm6.5-2H17v4h4.5v-4zm-1 1a1 1 0 011-1v4a3 3 0 003-3h-4zm1 1a1 1 0 01-1-1h4a3 3 0 00-3-3v4zm-4.5 0h4.5v-4H17v4zM15 10v4.5h4V10h-4zm1 1a1 1 0 01-1-1h4a3 3 0 00-3-3v4z",
    fill: "url(#addCourseIcon_svg__paint0_linear)",
    mask: "url(#addCourseIcon_svg__a)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "url(#addCourseIcon_svg__paint1_linear)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "addCourseIcon_svg__paint0_linear",
    x1: 22.5,
    y1: 22,
    x2: 9.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2091EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#1A9DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#0DBCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01D6B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "addCourseIcon_svg__paint1_linear",
    x1: 32,
    y1: 32,
    x2: 0,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2091EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#1A9DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#0DBCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01D6B9"
  })))));
}

export default SvgAddCourseIcon;